import React from 'react';
import classNames from 'classnames';

import { Link } from '../Link';
import { IconSuccess } from '../ui/IconSuccess';
import { IconFailure } from '../ui/IconFailure';

import styles from './index.module.scss';

type Props = {
    productUrl: string;
    productValue: string | boolean | number;
    hasExternalLink: boolean;
    openPopupList?: boolean;
    chartLabel: string;
    linkClickHandlerCallback?: (link: string) => void;
};

const Property: React.FC<Props> = ({ productUrl, productValue, hasExternalLink, chartLabel, openPopupList, linkClickHandlerCallback }) => {
    const propertyContainerClass = classNames({
        [styles.propertyValue]: true,
        [styles.toggleIconContainer]: typeof productValue === 'boolean',
    });
    const strProductValue = typeof productValue ==='string' ? {__html: productValue} : null;
    const renderProperty = () => {
        if (typeof productValue === 'boolean') return productValue ? <IconSuccess /> : <IconFailure />;

        //chartLabel is flag for view IconExternalLink
        if (productUrl) {
          return (
            <Link
                key={productValue}
                to={productUrl}
                separateTab={hasExternalLink}
                chartLabel={chartLabel}
                openPopup={openPopupList}
                clickHandlerCallback={linkClickHandlerCallback}
            >
                {productValue}
            </Link>
          );
        }

        return null;
    };

    if (productUrl || typeof productValue === 'boolean') {
        return <div className={propertyContainerClass}>{renderProperty()}</div>;
    }
    return <div className={propertyContainerClass} dangerouslySetInnerHTML={strProductValue} />
};

export default Property;
